"use client";

import { TwoColumnsPage } from "@templates/TwoColumnPage";
import type { IPageEditorial, IPageTwoColumns } from "@contentful-api/types/contentful";
import { isTwoColumnPage } from "@lib/utils/two-columns-page/isTwoColumnPage";
import { EditorialLayout } from "@templates/EditorialLayout";
import { MainWrapper } from "@components/ui/main-wrapper/mainWrapper";

interface CustomerServiceLegalClientProps {
    page: IPageEditorial | IPageTwoColumns;
}

export default function CustomerServiceLegalClient({ page }: CustomerServiceLegalClientProps) {
    return (
        <MainWrapper>
            <div hidden data-testid="legalPagesSlug" />
            {isTwoColumnPage(page) ? (
                <TwoColumnsPage page={page} />
            ) : (
                <EditorialLayout page={page} />
            )}
        </MainWrapper>
    );
}
